import React, { useEffect } from "react"
import { Link, withRouter } from "react-router-dom"
import { Popover, message } from "antd"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import qs from "qs"
import Cookies from 'js-cookie'
import Icon from "@ant-design/icons"
import {
	addUserInfo,
	addWorkInfo,
	setCurrentLogin,
} from "../../../../redux/reducers/baseInfo"
import * as SvgIcon from "../../../../assets/icon"
import * as API from "../../../../api"
import * as LOGIN_API from "../../../../api/loginNew"
import "./index.less"

const UserCenter: React.FC<any> = (props) => {
	const logout = async () => {
		const { code, msg } = await API.logout()
		if (code === 0) {
			localStorage.clear()
			Cookies.remove('access_token')
			props.actions.addUserInfo({ workid: "" })
			props.history.push(`/index`)
		} else {
			message.error(msg)
		}
	}
	const getQueryStringByName = (url, name) => {
		const result = url.match(new RegExp("[?&]" + name + "=([^&]+)", "i"))
		if (result == null || result.length < 1) {
			return ""
		}
		return result[1]
	}
	const login = () => {
		props.actions.setCurrentLogin("login")
	}
	const code = getQueryStringByName(props.location.search, "code")
	useEffect(() => {
		if (!code) return
		/// 本地调试
		// if (process.env.NODE_ENV === 'development') {
		// 	import('../../../../api/mock.json').then(res => {
		// 		const info = res.loginInfo.data
		// 		props.actions.addUserInfo(info.account)
		// 		props.actions.addWorkInfo(info.workinfo)
		// 		props.history.push(`/index`)
		// 	})
		// 	return
		// }
		const getUserInfo = async () => {
			const data = {
				client_id: process.env.REACT_APP_ID,
				client_secret: process.env.REACT_APP_SECRET,
				code: code,
				// redirect_uri: process.env.REACT_APP_REDIRECT_ENCODED,
				redirect_uri: location.href.split('?')[0],
				grant_type: "authorization_code",
			}
			try {
				const response = await fetch(
					`${process.env.REACT_APP_LOGIN}/oauth/token`,
					{
						method: "post",
						body: qs.stringify(data),
						headers: {
							"Content-Type": "application/x-www-form-urlencoded",
						},
					}
				)
				const { access_token } = await response.json()
				if (!access_token) {
					return
				}
				const { code, data: loginData, msg } = await API.login({ access_token })
				if (code !== 0) {
					message.error(msg)
					props.history.push(`/index`)
					return
				}
				const workId = String(loginData?.workinfo?.workId)
				const { code: loginNewCode, msg: loginNewMsg, result: loginNewResult } =
					await LOGIN_API.login({ loginType: "3", networkId: workId })
				if (loginNewCode !== "0000") {
					message.error(loginNewMsg || "登录失败")
					props.history.push(`/index`)
					return
				}
				const accountInfo = {
					ispublicnetwork: loginData.workinfo ? 0 : 1,
					userid: loginNewResult.userId,
					username: loginNewResult.userInfo.username,
					workid: workId,
				}
				// props.actions.addUserInfo(loginData.account)
				// props.actions.addWorkInfo(loginData.workinfo)
				props.actions.addUserInfo(accountInfo)
				props.actions.addWorkInfo(loginNewResult.userInfo)
				props.history.push(`/index`) // 这里只是为了不让链接显示太多统一登录的参数
			} catch {
				message.error("登录失败！请刷新重试")
			}
		}
		getUserInfo()
	}, [code])

	return props.userInfo && props.userInfo.username ? (
		<Popover
			overlayClassName="user-dropdown-menu"
			placement="bottomRight"
			trigger="click"
			content={
				<ul>
					<li>
						<Icon component={SvgIcon.DraftBox}></Icon>
						<Link to="/main/drafts">
							<span>草稿箱</span>
						</Link>
					</li>
					<li onClick={logout}>
						<Icon component={SvgIcon.LogOut}></Icon>
						<span>退出登录</span>
					</li>
				</ul>
			}
		>
			<div
				className="user-center"
				style={
					props.userInfo.userType === "IOCenter" ? { fontSize: "12px" } : {}
				}
			>
				<span>
					{props.userInfo.userType === "IOCenter"
						? props.userInfo.username
						: props.userInfo.username.substr(-2, 2)}
				</span>
			</div>
		</Popover>
	) : (
		<div className="user-center">
			<span onClick={login}>登录</span>
		</div>
	)
}

function mapStateToProps(state) {
	return {
		userInfo: state.baseInfo.userInfo,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{ addUserInfo, addWorkInfo, setCurrentLogin },
			dispatch
		),
	}
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(UserCenter))
